import { render, staticRenderFns } from "./i-modal.vue?vue&type=template&id=4060e141&scoped=true&"
import script from "./i-modal.vue?vue&type=script&lang=js&"
export * from "./i-modal.vue?vue&type=script&lang=js&"
import style0 from "./i-modal.vue?vue&type=style&index=0&id=4060e141&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060e141",
  null
  
)

export default component.exports